import { SsoProviderService, type CheckDomainBodyDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  requestBody: CheckDomainBodyDto;
};

export const checkDomain = ({ call, requestBody }: TParams) =>
  call(() => SsoProviderService.checkDomain({ requestBody }));
